export default {"src":"/_next/static/media/blue_diji.0f6fcf23.svg","height":420,"width":1700};